import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams, useOutletContext } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import { AiOutlineSolution } from "react-icons/ai"
import { FaRegSquareCheck } from "react-icons/fa6"
import { GoIssueReopened, GoReport } from "react-icons/go"

import PopupModal from 'Shared/Components/PopupModal'
import { IconButtonComponent } from 'Shared/Components/Icon'
import { apiUrl, webUrl } from 'Shared/utils'
import StatusChip from './StatusChip'
import { Box } from '@mui/material'

const Player = ({ type, record_id, toggle }) => {
  const { getAccessTokenSilently, logout } = useAuth0()
  const { project } = useParams()

  const [token, setToken] = useState()

  const getToken = async () => {
    try {
      const res = await getAccessTokenSilently({
        scope: "openid offline_access",
        grant: "refresh_token",
        detailedResponse: true
      })
      
      return res.access_token
    }
    catch (e){
      logout({ logoutParams: { returnTo: webUrl } })
    }
  }

  useEffect(() => {
    const init = async() => {
      const token = await getToken()
      setToken(token)
    }

    init()
  }, [])

  return (<>
    {token && 
      <div style={{ flex: 1, width: "100%", overflowX: "hidden", overflowY: "hidden" }}>
        {(type === "video" && record_id != null) &&
          <iframe src={`${apiUrl}/ai_playback/templates/video.html?record_id=${record_id}&project=${project}&token=${token}`} style={{ width: "100%", height: "100%" }}/>
        }

        {(type === "snapshot" && record_id != null) && 
          <iframe src={`${apiUrl}/ai_playback/templates/snapshot.html?record_id=${record_id}&project=${project}&token=${token}`} style={{ width: "100%", height: "100%" }}/>
        }
      </div>
    }
  </>)
}

const PlaybackModal = ({ type, item, update, toggle }) => {  
  const { t } = useTranslation()
  const { alertTypes, alertEvents } = useOutletContext()

  return (
    <PopupModal isOpen={item != null} height="80%" width="80%" close toggle={toggle}>
      {item && 
        <div style={{ width: "100%", "height": "100%", display: "flex", flexFlow: "column" }}>
          <Box sx={{ paddingLeft: "20px", paddingRight: "20px", display: "flex", flexFlow: { xs: "column", md: "row" }, justifyContent: { xs: "start", md: "space-between" }  }}>
            <div>
              <div>{t("general_datetime")}: {item["datetime"]}</div>
              <div>{t("alert_message")}: {`${t(alertTypes[item["type"]])} (${t(alertEvents[item["type"]][item["event"]])})`}</div>
              <div>{t("alert_target")}: {item["target"]}</div>
            </div>

            <Box sx={{ display: "flex", flexFlow: { xs: "row", md: "column" }, marginTop: { xs: "5px", md: "0px" }, alignItems: "center" }}>
              <div style={{ display: "flex" }}>
                <StatusChip status={item["status"]}/>
              </div>

              <div>
                <IconButtonComponent title={t("alert_acknowledge")} onClick={() => update("acknowledge", [item["record_id"]]) }>
                  <AiOutlineSolution size={20}/>
                </IconButtonComponent>
                
                <IconButtonComponent title={t("alert_resolve")} onClick={() => update("resolve", [item["record_id"]]) }>
                  <FaRegSquareCheck size={20}/>
                </IconButtonComponent>

                <IconButtonComponent title={t("alert_invalid")} onClick={() => update("invalid", [item["record_id"]]) }>
                  <GoReport size={20}/>
                </IconButtonComponent>

                <IconButtonComponent title={t("alert_reopen")} onClick={() => update("reopen", [item["record_id"]]) }>
                  <GoIssueReopened size={20}/>
                </IconButtonComponent>
              </div>
            </Box>
          </Box>

          <div style={{ flex: 1, display: "flex", width: "100%", padding: "10px" }}>
            <Player type={type} record_id={item["record_id"]} toggle={toggle}/>
          </div>
        </div>
      }
    </PopupModal>
  )
}

export default PlaybackModal
